import { createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import withRestProps from 'helpers/withRestProps';
import cns from 'classnames';

import cn from './styles.local.less';

class Index extends PureComponent {
  static propTypes = {
    bsClass: PropTypes.string,
    bsSize: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    rest: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.scrolledRef = createRef();
    this.scrolledElement = null;
  }

  componentDidMount() {
    this.scrolledElement = this.scrolledRef.current;

    if (this.scrolledElement) {
      document.body.style.overflow = 'auto';
      disableBodyScroll(this.scrolledElement, { allowTouchMove: true });
    }
  }

  componentWillUnmount() {
    if (this.scrolledElement) {
      enableBodyScroll(this.scrolledElement);
    }
  }

  render() {
    const { className, bsClass, children, bsSize, rest } = this.props;

    return (
      <div
        {...rest}
        role="dialog"
        ref={this.scrolledRef}
        className={cns(cn.root, bsClass, className)}
      >
        <div
          className={cns(
            {
              'modal-lg': bsSize === 'lg',
              'modal-sm': bsSize === 'sm',
            },
            `${bsClass}-dialog`,
          )}
        >
          <div role="document" className={`${bsClass}-content`}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRestProps()(Index);
